import React, { Component, Fragment } from 'react'
import { observer, inject } from 'mobx-react'
import { getStringByTextKey } from '@/utils/getStringByTextKey'
import './Navbar.scss'
import { DropdownButton, MenuItem } from 'react-bootstrap'
import moment from 'moment'

@inject('store')
@observer
export default class NavbarConsoleComponent extends Component {
  commonStore = this.props.store.commonStore
  render() {
    const {
      logout,
      goConsole,
      goSite,
      goLicense,
      goBill,
      goCoupon,
      goTrial,
      goNotice,
      goUser,
      goAdminUser,
      goFasooDtoStat,
      goQnA,
      goUpc,
      product,
      handleChangeForDropdown,
      path
    } = this.props
    const { userInfo } = this.commonStore

    return (
      <Fragment>
        <header id="navbar">
          <div
            className="icon_fasoo"
            onClick={goConsole}
            style={{ height: 31 }}
          ></div>
          <div className="subMenu">
            <div className="inline-block vertical-middle">
              <div className="userInfo inline-block vertical-middle">
                {userInfo.userInfo.userCode.substr(0, 2)}
              </div>
            </div>

            <button type="button" onClick={logout} className="btn btn-green">
              {getStringByTextKey('admin.common.logout')}
            </button>
          </div>
        </header>
        <nav className="fasooLeftNav">
          <ul className="leftNav-menu">
            {/* {userInfo.userInfo.menuScope.includes('portal_dashboard') ? (
              <li className={`site_mgnt ${path === 'console' ? 'active' : ''}`}>
                <a onClick={goConsole}>
                  {getStringByTextKey('admin.portal_dashboard')}
                </a>
              </li>
            ) : (
              ''
            )} */}
            {userInfo.userInfo.menuScope.includes('portal_site') ? (
              <li className={`site_mgnt ${path === 'site' ? 'active' : ''}`}>
                <a onClick={goSite}>
                  {getStringByTextKey('admin.portal_site')}
                </a>
              </li>
            ) : (
              ''
            )}
            {/* {userInfo.userInfo.menuScope.includes('portal_license') ? (
              <li className={`site_mgnt ${path === 'license' ? 'active' : ''}`}>
                <a onClick={goLicense}>
                  {getStringByTextKey('admin.portal_license')}
                </a>
              </li>
            ) : (
              ''
            )} */}
            {/* {userInfo.userInfo.menuScope.includes('portal_price') ? (
              <li className={`site_mgnt ${path === 'bill' ? 'active' : ''}`}>
                <a onClick={goBill}>
                  {getStringByTextKey('admin.portal_price')}
                </a>
              </li>
            ) : (
              ''
            )} */}
            {/* {userInfo.userInfo.menuScope.includes('portal_coupon') ? ( */}
            <li className={`site_mgnt ${path === 'coupon' ? 'active' : ''}`}>
              <a onClick={goCoupon}>
                {getStringByTextKey('admin.portal_coupon')}
              </a>
            </li>
            {/* ) : (
              ''
            )} */}
            {userInfo.userInfo.menuScope.includes('portal_trial') ? (
              <li className={`site_mgnt ${path === 'trial' ? 'active' : ''}`}>
                <a onClick={goTrial}>
                  {getStringByTextKey('admin.portal_trial')}
                </a>
              </li>
            ) : (
              ''
            )}
            {/* {userInfo.userInfo.menuScope.includes('portal_notification') ? (
              <li className={`site_mgnt ${path === 'notice' ? 'active' : ''}`}>
                <a onClick={goNotice}>
                  {getStringByTextKey('admin.portal_notification')}
                </a>
              </li>
            ) : (
              ''
            )} */}
            {userInfo.userInfo.menuScope.includes('portal_user') ? (
              <li className={`site_mgnt ${path === 'user' ? 'active' : ''}`}>
                <a onClick={goUser}>
                  {getStringByTextKey('admin.portal_user')}
                </a>
              </li>
            ) : (
              ''
            )}
            {/* {userInfo.userInfo.menuScope.includes('portal_admin_assignment') ? ( */}
            <li className={`site_mgnt ${path === 'upc' ? 'active' : ''}`}>
              <a onClick={goUpc}>{'UPC'}</a>
            </li>
            {/* ) : (
              ''
            )} */}
            {userInfo.userInfo.menuScope.includes('portal_admin_assignment') ? (
              <li
                className={`site_mgnt ${path === 'adminUser' ? 'active' : ''}`}
              >
                <a onClick={goAdminUser}>
                  {getStringByTextKey('admin.portal_admin_assignment')}
                </a>
              </li>
            ) : (
              ''
            )}
            {userInfo.userInfo.menuScope.includes('portal_fasoo_dto_stat') ? (
              <li
                className={`site_mgnt ${
                  path === 'fasooDtoStat' ? 'active' : ''
                }`}
              >
                <a onClick={goFasooDtoStat}>
                  {getStringByTextKey('admin.portal_fasoo_dto_stat')}
                </a>
              </li>
            ) : (
              ''
            )}
          </ul>

          <p className="leftBottom">
            <span className="companyName">
              {/* {'© ' + moment().format('YYYY') + ' Fasoo'} */}
              {'© Fasoo'}
            </span>
          </p>
        </nav>
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/FasooConsole/Navbar/index.js